import { Component, OnInit, OnDestroy } from '@angular/core';
import { EditPbaErrorResponse, EditPbaModalPayload, Pba } from '../../../shared/models';

import {
  ClosableModalWithErrorResponseModel
} from '../../../shared/components/base/closable-modal-with-error-response-model';

import { NotificationService, PbasService } from '../../../shared/services';
import { ModalService } from '../../../shared/modules/modal';

@Component({
  selector: 'edit-pba-modal',
  templateUrl: './edit-pba-modal.component.html',
})
export class EditPbaModalComponent
  extends ClosableModalWithErrorResponseModel<EditPbaErrorResponse>
  implements OnInit, OnDestroy {
  data: EditPbaModalPayload = new EditPbaModalPayload();
  pba: Pba = new Pba();
  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _pbaService: PbasService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.getPba();
    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  editPba(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    if (this.pba.description === null) {
      this.pba.description = '';
    }

    this._pbaService.edit(this.pba.pbaId, this.pba).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  private getPba() {
    this._pbaService.show(this.data.pbaId).subscribe(({ data }) => {
      this.pba = data;
    });
  }
}
